export const VIEW_BTN_ACTIVE = {
  backgroundColor: "#6f42c1",
  borderColor: "#6f42c1",
  fontSize: "0.82rem",
  padding: "4px 12px",
};

export const VIEW_BTN_INACTIVE = {
  backgroundColor: "#FBF9FF",
  color: "#3F4254",
  borderColor: "#EFEBFC",
  fontSize: "0.82rem",
  padding: "4px 12px",
};

export const OUTLINE_BTN = {
  borderColor: "#EFEBFC",
  backgroundColor: "#FBF9FF",
  color: "#6f42c1",
  fontSize: "0.86rem",
  padding: "5px 12px",
  borderRadius: "6px",
  borderWidth: "1.5px",
  transition: "all 0.2s ease",
  boxShadow: "0px 4px 10px rgba(111, 66, 193, 0.04)",
};

export const CARD_TITLE = {
  fontSize: "1.15rem",
  color: "#181C32",
  letterSpacing: "-0.2px",
};
